import { faBoxOpen, faComment, faNoteSticky, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useContext, useState } from 'react';
import { Accordion, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import usePrivileges from '../../../Auth/usePrivileges';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import SetLotStatusDialog from '../../../Dialogs/SetLotStatusDialog';
import { Section } from '../../../Types/Section';
import GradingCommentsSection from '../LotDetailsComponents/GradingCommentsSection';
import { LotStatusControl, ProcessingStatusControl } from '../LotDetailsComponents/LotStatusControls';
import PackagesSection from '../LotDetailsComponents/PackagesSection/PackagesSection';
import QIRSection_QIRMS from '../LotDetailsComponents/QIRSection_QIRMS';
import { GradeFields } from '../LotDetailsComponents/SummaryFields/GradeFields';
import { PackageCountFields } from '../LotDetailsComponents/SummaryFields/LotDataFields/PackageCountField';
import { LotTimingFields } from '../LotDetailsComponents/SummaryFields/LotTimingFields';
import { LotWeightFields } from '../LotDetailsComponents/SummaryFields/LotWeightFields';
import WarningsSection from '../LotDetailsComponents/WarningsSection';
import { LotDetailSection } from '../LotDetailSection';
import BlockLotButton from '../LotSummaryButtons/BlockLotButton';
import DeleteLotButton from '../LotSummaryButtons/DeleteLotButton';
import ExportCollectionUpdateButton from '../LotSummaryButtons/ExportCollectionUpdateButton';
import LockLotButton from '../LotSummaryButtons/LockLotButton';
import LotNumberComponent from '../LotSummaryButtons/LotNumberComponent';
import ProcessAgainButton from '../LotSummaryButtons/ProcessAgainButton';
import SplitLotButton from '../LotSummaryButtons/SplitLotButton';
import UnlockLotButton from '../LotSummaryButtons/UnlockLotButton';
import ViewReportButton from '../LotSummaryButtons/ViewReportButton';
import { SectionNavigation } from '../SectionNavigation';

function LotDetails_BRCP_HoldingLot() {

    const { t } = useTranslation();
    const {
        lotDetail,
        lotDetail: {
            summary: {
                lotNumber,
                businessUnitCode,
                currentStatus,
                isLocked
            },
            packages
        }
    } = useContext(LotDetailContext);
    const { admin } = usePrivileges(businessUnitCode);
    const [loading, setLoading] = useState(false);
    const [showSetLotStatusDialog, setShowSetLotStatusDialog] = useState<boolean>(false);

    const sections: Section[] = [
        { name: 'warnings', title: 'LotDetails.Warnings.Title', icon: faTriangleExclamation, component: <WarningsSection /> },
        { name: 'QIRMSqirs', title: 'LotDetails.QIRs.Title', icon: faNoteSticky, component: <QIRSection_QIRMS showCreateQIRButton={true} /> },
        { name: 'packages', title: 'LotDetails.Packages.Title', titleSuffix: `${packages.length}`, icon: faBoxOpen, component: <PackagesSection packagesCanBeEdited={true} /> },
        { name: 'gradingcomments', title: 'LotDetails.GradingComments.Title', icon: faComment, component: <GradingCommentsSection /> },
    ];

    return (lotDetail &&
                <>
                    <Row className="mb-3">
                        <Col sm={12} md={3}>
                            <LotNumberComponent
                                lotNumber={lotNumber}
                                lotStatus={currentStatus}
                                isLocked={isLocked} />
                        </Col>
                        <Col className="d-flex flex-wrap gap-1 justify-content-md-end">
                            <ProcessAgainButton setLoading={setLoading} />
                            <SplitLotButton />
                            <ViewReportButton />
                            <ExportCollectionUpdateButton />
                            <BlockLotButton setLoading={setLoading} />
                            <LockLotButton setLoading={setLoading} />
                            <UnlockLotButton setLoading={setLoading} />
                            <DeleteLotButton setLoading={setLoading} />
                        </Col>
                    </Row>
                    <Row className="mb-1">
                        <GradeFields hasPackoutGrade={false} showGradeDialog={false} />
                    </Row>
                    <Row className="gy-1 mb-1">
                        <LotWeightFields hasLotSize={false} />
                        <PackageCountFields />
                    </Row>
                    <Row className="mb-1">
                        <LotTimingFields />
                    </Row>
                    <Row id="lot-summary-lot-processing-state" className="gy-1 mb-3">
                        <LotStatusControl setShowSetLotStatusDialog={setShowSetLotStatusDialog} />
                        <ProcessingStatusControl setShowSetLotStatusDialog={setShowSetLotStatusDialog} />
                    </Row>

                    <SectionNavigation sections={sections} />

                    <Accordion defaultActiveKey={['QIRMSqirs', 'labresults', 'packages']} alwaysOpen className="mb-2">
                        {sections.map(section =>
                            <LotDetailSection
                                key={section.name}
                                name={section.name}
                                icon={section.icon}
                                title={section.title}
                                titleSuffix={section.titleSuffix}
                                component={section.component} />)
                        }
                    </Accordion>
                    <SetLotStatusDialog showDialog={admin && showSetLotStatusDialog} closeDialog={() => setShowSetLotStatusDialog(false)} />
                </>
    );
}

export default LotDetails_BRCP_HoldingLot;